import React, { useState } from "react";
import { Heart } from "lucide-react";
import "./PostCard.css";
import { useTranslation } from "react-i18next";
import API from "../utils/axiosInstance";


const PostCard = ({ post }) => {
  const [comments, setComments] = useState([]);
  const [commentText, setCommentText] = useState("");
  const [showComments, setShowComments] = useState(false);
  const [liked, setLiked] = useState(post.userLiked || false);
  const [likeCount, setLikeCount] = useState(post.likeCount || 0);
  const [commentCount, setCommentCount] = useState(post.commentCount || 0);

  const { t, i18n } = useTranslation();
 const loadComments = async () => {
  try {
    const res = await API.get(`/subscriptions/posts/${post.id}/comments`);
    setComments(res.data || []);
  } catch (err) {
    console.error("Failed to load comments", err);
  }
};


  const submitComment = async () => {
  if (!commentText.trim()) return;

  try {
    const res = await API.post(`/subscriptions/posts/${post.id}/comments`, {
      content: commentText
    });

setComments(prev => [...prev, res.data]);
    setCommentText("");
     // 🔥 IMPORTANT — increase count instantly
    setCommentCount(prev => prev + 1);
  } catch (err) {
    console.error("Comment failed", err);
  }
};


 const toggleLike = async () => {
  try {
    if (liked) {
      await API.delete(`/subscriptions/posts/${post.id}/like`);
      setLikeCount(prev => prev - 1);
    } else {
      await API.post(`/subscriptions/posts/${post.id}/like`);
      setLikeCount(prev => prev + 1);
    }

    setLiked(!liked);
  } catch (err) {
    console.error("Like action failed", err);
  }
};


  return (
    <div className="post-card"  dir={["ar","fa","ir","he"].includes(i18n.language)?"rtl":"ltr"}
      style={{
        flexDirection: ["ar","fa","ir","he"].includes(i18n.language) ? "row-reverse" : "row",
      }}>
      <div className="post-header">
        <h4 className="post-title">{post.title || "Post"}</h4>
        <span className="post-date">
          {new Date(post.createdAt).toLocaleDateString()} 
          {new Date(post.createdAt).toLocaleTimeString()}
        </span>
      </div>

      <div className="post-content">
        <div dangerouslySetInnerHTML={{ __html: post.content || "" }} />
      </div>

      {post.attachmentUrl && (
        <div className="post-attachment">
          {post.type === "video" ? (
            <div className="video-container">
              <video controls className="video-player">
                <source src={post.attachmentUrl} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          ) : (
            <a href={post.attachmentUrl} target="_blank" rel="noreferrer" className="attachment-link">
              📎 Download Attachment
            </a>
          )}
        </div>
      )}

      <div className="post-footer">
        <button 
          className={`like-btn ${liked ? 'liked' : ''}`}
          onClick={toggleLike}
          title={liked ? "Unlike" : "Like"}
        >
          <Heart 
            size={16} 
            fill={liked ? "#ff4757" : "none"} 
            color={liked ? "#ff4757" : "#666"}
            style={{ transition: "all 0.2s" }}
          />
          <span className="like-count">{likeCount}</span>
        </button>
        <button 
          className="toggle-comments-btn"
        onClick={() => {
  setShowComments(prev => {
    if (!prev && comments.length === 0) {
      loadComments();
    }
    return !prev;
  });
}}

        >
          💬 {commentCount} {t("Comments")}
        </button>
      </div>

      {showComments && (
        <div className="comments-section">
          <div className="comments-list">
            {comments.length === 0 ? (
              <p className="no-comments">No comments yet. Be the first to comment!</p>
            ) : (
              comments.map((c) => (
                <div key={c.id} className="comment">
                  <p className="comment-author"><strong>{c.author?.name || "User"}</strong> · {new Date(c.createdAt).toLocaleDateString()}
</p>
                  <p className="comment-text">{c.content}</p>
                </div>
              ))
            )}
          </div>

          <div className="comment-input">
            <textarea 
              value={commentText} 
              onChange={(e) => setCommentText(e.target.value)} 
              placeholder="Share your thoughts..."
              className="textarea-input"
            />
            <button onClick={submitComment} className="submit-btn">Reply</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PostCard;
